import { FriendshipRequest } from './FriendshipRequest';
export { FriendshipRequest };
import { Friendship } from './Friendship';
export { Friendship };
import { Session } from './Session';
export { Session };
import { Share } from './Share';
export { Share };
import { Upload } from './Upload';
export { Upload };
import { User } from './User';
export { User };

const resourceMap = {
  friendship_requests: FriendshipRequest,
  friendships: Friendship,
  sessions: Session,
  shares: Share,
  uploads: Upload,
  users: User,
};
export default resourceMap;
